
export const getAuthSuccessRouter = (state) => {
  if (state.router.location.state) {
    return state.router.location.state.authSuccessRouter;
  }
  return undefined;
};